import type { BillingPeriod } from '@/entities/plan';
import type { PaymentMethod } from '@/entities/payment-method';
import type { EmailFormData } from '@/shared/lib/validation/registration-wizard/email';
import type { ProfileFormData } from '@/shared/lib/validation/registration-wizard/profile';
import type { CompanyFormData } from '@/shared/lib/validation/registration-wizard/company';
import type { SignupCredentialsFormData } from '@/shared/lib/validation/registration-wizard/credentials';
import type { BillingAddressFormData } from '@/shared/lib/validation/registration-wizard/billing-address';


export type WizardStep = 'email' | 'profile' | 'plan' | 'payment' | 'confirmation';


export type WizardData = {
    billing_address?: BillingAddressFormData;
    company?: CompanyFormData;
    credentials?: SignupCredentialsFormData;
    email?: EmailFormData;
    payment_method?: PaymentMethod;
    payment_method_id?: string;
    plan?: {
        billing_period: BillingPeriod;
        plan_id: string;
    };
    profile?: ProfileFormData;
};


export type WizardState = {
    step: WizardStep;
    data: WizardData;
};


export const STEP_ORDER: WizardStep[] = [ 'email', 'profile', 'plan', 'payment', 'confirmation' ];


export const getStepNumber = (step: WizardStep): number => {
    return STEP_ORDER.indexOf(step);
};


export const initialState: WizardState = {
    step: 'email',
    data: {},
};
